import {CartItems} from '../features/cart-items';
import {register} from '../vendor/theme-scripts/theme-sections';
import {initQtySection} from '../features/quantity-selector';
import {accordion} from '../features/accordion';
import {ShippingCalculator} from '../features/cart-shipping';

const selectors = {
  ajaxDisable: 'data-ajax-disable',
  shipping: '[data-shipping-estimate-form]',
  input: '[data-update-cart]',
  update: '[data-update-button]',
  bottom: '[data-cart-bottom]',
  upsellWrapper: '[data-cart-page-upsell-wrapper]',
};

const classes = {
  dirty: 'cart--dirty',
  heartBeat: 'heart-beat',
};

const cartSection = {
  onLoad() {
    const hasShipping = this.container.querySelector(selectors.shipping);
    if (hasShipping) {
      new ShippingCalculator(this);
    }

    this.disabled = this.container.getAttribute(selectors.ajaxDisable) == 'true';

    if (this.disabled) {
      this.cart = new AjaxDisabledCart(this);
      return;
    }

    this.cart = new CartItems(this);
    const initPromise = this.cart.init();
    initPromise.then(() => {
      this.cart.loadHTML(true);
    });
  },
};

class AjaxDisabledCart {
  constructor(section) {
    window.theme.state.cartOpen = true;
    this.section = section;
    this.container = section.container;
    this.inputs = this.container.querySelectorAll(selectors.input);
    this.quantityWrappers = this.container.querySelectorAll(selectors.qty);
    this.updateBtn = this.container.querySelector(selectors.update);
    this.upsellWrapper = this.container.querySelector(selectors.upsellWrapper);
    this.initQuantity();
    this.initInputs();
    if (this.upsellWrapper) {
      this.moveUpsell();
    }

    document.addEventListener(
      'theme:cart:reload',
      function () {
        window.location.reload();
      }.bind(this)
    );
  }

  initQuantity() {
    initQtySection(this.container);
  }

  moveUpsell() {
    const bottom = this.container.querySelector(selectors.bottom);
    bottom.insertBefore(this.upsellWrapper, bottom.firstChild);
  }

  initInputs() {
    this.inputs.forEach((input) => {
      input.addEventListener(
        'change',
        function () {
          this.updateBtn.classList.add(classes.dirty);
          this.updateBtn.classList.add(classes.heartBeat);
          setTimeout(
            function () {
              this.updateBtn.classList.remove(classes.heartBeat);
            }.bind(this),
            1300
          );
        }.bind(this)
      );
    });
  }
}

register('cart', [cartSection, accordion]);
